import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';

import FormattedCurrencyContainer from '../../../components/formatted-currency/container';

import style from './cost-review-line-item-subtotal.module.css';

const messages = defineMessages({
  postage: {
    description: 'costReviewLineItemSubtotal.postageCostSubtotal',
    defaultMessage: 'Postage Cost Subtotal: {subTotal}',
    id: 'IZwJp6',
  },
  insurance: {
    description: 'costReviewLineItemSubtotal.insuranceCostSubtotal',
    defaultMessage: 'Insurance Cost Subtotal: {subTotal}',
    id: '46tJ7x',
  },
});

const CostReviewLineItemService = ({ subtotal = 0.0, subtotalCurrencyCode = null, insuranceLineItem = false }) => {
  const message = insuranceLineItem ? messages.insurance : messages.postage;

  return (
    <div className={style['subtotal-container']}>
      <div className={style.subtotal}>
        <FormattedMessage
          {...message}
          values={{
            subTotal: <FormattedCurrencyContainer currencyCode={subtotalCurrencyCode} value={subtotal} />,
          }}
        />
      </div>
    </div>
  );
};

CostReviewLineItemService.propTypes = {
  subtotal: PropTypes.number,
  subtotalCurrencyCode: PropTypes.string,
  insuranceLineItem: PropTypes.bool,
};

export default CostReviewLineItemService;
